import { setter } from "./setter";
import WidgetCommonMixin from "./WidgetCommonMixin.js";

export default {
  mixins: [WidgetCommonMixin],
  props: {
    field: {
      type: Object,
      default: () => {},
    },
    item: {
      type: Object,
      default: () => {},
    },
    fields: { type: Array, default: () => [] },
    design: { type: Boolean, default: false },
    selector: { type: Object, default: null },
    formState: { type: Object, default: null },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    handleError: function (msg) {
      this.$emit("error", msg);
    },
    change: function (value) {
      this.emitFieldChange("ContainerWidgetMixin", value);
    },
    fieldsChanged: function (fields) {
      if (!this.disabled) {
        this.field.fields = fields;

        this.$emit("fields-change", this.fields);
      }
    },
  },
  computed: {
    the_item() {
      var val = this.item;

      if (val) {
        if (!(this.field.code in val)) {
          setter(this, val, this.field.code, null); // Ensure there is "a" key
        }

        return val;
      }
      return {};
    },
  },
};
